// The selected section ("band"): its name, whether it is free (exact
// positions, fixed height) or flowing (stacks and grows), height, repeating on
// every page, and its own background/border.

import React from "react";
import FeatherIcon from "feather-icons-react";
import { Section, Field, NumberInput, Segmented, TextInput } from "../controls";
import StyleEditor from "../StyleEditor";

export default function BandPanel({ band, palette, updateBand, onConvert, onDelete, onDuplicate, onMove, canMoveUp, canMoveDown }) {
  return (
    <>
      <Section title="Section">
        <Field label="Name">
          <TextInput value={band.label} maxLength={40} onChange={(v) => updateBand({ label: v }, "band-label")} />
        </Field>
        <Field
          label="Kind"
          hint={
            band.kind === "free"
              ? "Free: place things exactly where you want. Fixed height."
              : "Flowing: things stack top to bottom and the section grows — use it for the line items table."
          }
        >
          <Segmented
            ariaLabel="Section kind"
            value={band.kind}
            onChange={(v) => v && v !== band.kind && onConvert(v)}
            options={[
              { value: "free", label: "Free" },
              { value: "flow", label: "Flowing" },
            ]}
          />
        </Field>
        {band.kind === "free" && (
          <>
            <Field label="Height">
              <NumberInput value={band.height} min={5} max={250} step={1} unit="mm" onChange={(v) => updateBand({ height: v }, "band-height")} />
            </Field>
            <Field
              label="Repeat on every page"
              hint="Pinned sections print on every page of a long invoice — handy for a letterhead or footer."
            >
              <Segmented
                ariaLabel="Repeat on every page"
                value={band.pin || "none"}
                onChange={(v) => updateBand({ pin: v || "none" })}
                options={[
                  { value: "none", label: "No" },
                  { value: "top", label: "Top" },
                  { value: "bottom", label: "Bottom" },
                ]}
              />
            </Field>
          </>
        )}
        <div className="td-row-gap">
          <button type="button" className="td-btn td-btn--ghost td-btn--sm" disabled={!canMoveUp} onClick={() => onMove(-1)}>
            <FeatherIcon icon="arrow-up" size={13} /> Move up
          </button>
          <button type="button" className="td-btn td-btn--ghost td-btn--sm" disabled={!canMoveDown} onClick={() => onMove(1)}>
            <FeatherIcon icon="arrow-down" size={13} /> Move down
          </button>
          <button type="button" className="td-btn td-btn--ghost td-btn--sm" onClick={onDuplicate}>
            <FeatherIcon icon="copy" size={13} /> Duplicate
          </button>
          <button type="button" className="td-btn td-btn--danger td-btn--sm" onClick={onDelete}>
            <FeatherIcon icon="trash-2" size={13} /> Delete
          </button>
        </div>
      </Section>
      <StyleEditor title="Section text" style={band.style} palette={palette} onChange={(s) => updateBand({ style: s })} boxOpen />
    </>
  );
}
